import { useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { DateCalendar } from '@mui/x-date-pickers'

import type { Gebied } from '@models/Gebied'
import { formatDateToISOWeek } from '@util/date-util'

import { SelectObject } from '../../../core/components/SelectObject'
import { useUpdateGeblokkeerdeWeek } from '../../hooks/useUpdateGeblokkeerdeWeek'

interface Props {
  onClose: () => void
  gebieden: Gebied[]
}

export const GeblokkeerdeWeekDialog = ({ onClose, gebieden }: Props) => {
  const { mutate: updateGeblokkeerdeWeek, isPending } =
    useUpdateGeblokkeerdeWeek()

  const [date, setDate] = useState(new Date())
  const [gebied, setGebied] = useState<Gebied | null>(null)
  const [errors, setErrors] = useState({
    gebied: '',
  })

  const validate = () => {
    let gebiedError = false

    if (!gebied) {
      gebiedError = true

      setErrors((prev) => ({
        ...prev,
        gebied: 'Selecteer een gebied',
      }))
    }

    return !gebiedError
  }

  const handleClose = () => {
    setErrors({ gebied: '' })
    onClose()
  }

  const handleSubmitClick = () => {
    const valid = validate()

    if (valid) {
      updateGeblokkeerdeWeek(
        {
          geblokkeerdeWeek: {
            week: formatDateToISOWeek(date),
            status: 'actief',
            gebiedscode: gebied!.code,
          },
        },
        { onSuccess: () => handleClose() },
      )
    }
  }

  return (
    <Dialog open>
      <DialogTitle>Week blokkeren</DialogTitle>

      <DialogContent>
        <SelectObject
          options={gebieden}
          onChange={setGebied}
          value={gebied}
          label="Selecteer gebied"
          error={!!errors['gebied']}
          helperText={errors['gebied']}
        />

        <DialogContentText sx={{ mt: 2 }}>
          Selecteer een willekeurige datum binnen de gewenste week
        </DialogContentText>
      </DialogContent>

      <DateCalendar
        value={date}
        onChange={(value) => {
          if (value) setDate(value)
        }}
        displayWeekNumber
        showDaysOutsideCurrentMonth
      />

      <DialogActions>
        <Button onClick={handleClose} variant="text" autoFocus>
          Annuleren
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmitClick}
          disabled={isPending}
          endIcon={<AddIcon />}
        >
          Week blokkeren
        </Button>
      </DialogActions>
    </Dialog>
  )
}
